import { render, staticRenderFns } from "./QButtonPanel.vue?vue&type=template&id=31793f58&scoped=true&"
import script from "./QButtonPanel.vue?vue&type=script&lang=js&"
export * from "./QButtonPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31793f58",
  null
  
)

export default component.exports